import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { PaginatedLoadingTable } from '@artprov/design-system'
import { GrillaSinResultados } from '@/common/components/mensajes/GrillaSinResultados'
import { RESPONSE_HEADERS } from '@/common/utils/constants/headers'
import { cuentasSeleccionColumns } from '../constants/columns.jsx'
import { MENSAJES_GRILLA, PAGE_SIZE_INICIAL } from '../constants/textos.js'

const resolverMensajeVacio = ({ error, hayFiltroAplicado }) => {
  if (error) return MENSAJES_GRILLA.ERROR
  if (hayFiltroAplicado) return MENSAJES_GRILLA.SIN_RESULTADOS
  return MENSAJES_GRILLA.SIN_CUENTAS
}

export default function CuentasSeleccionTable({
  headers,
  tableData,
  onPageChange,
  isLoading,
  hayFiltroAplicado,
  error,
}) {
  const filas = isLoading ? [] : tableData
  const mostrarVacio = !isLoading && filas.length === 0

  const mensajeVacio = resolverMensajeVacio({ error, hayFiltroAplicado })

  const normalizedHeaders = useMemo(() => {
    const total = Number(headers?.[RESPONSE_HEADERS.TOTAL_COUNT])
    return {
      [RESPONSE_HEADERS.TOTAL_COUNT]: Number.isFinite(total) ? total : 0,
    }
  }, [headers])

  return (
    <div className="tabla-fix sin-checks">
      <div className="w-full overflow-x-auto">
        <div className="min-w-[860px] md:min-w-0">
          <PaginatedLoadingTable
            columns={cuentasSeleccionColumns}
            data={filas}
            headers={normalizedHeaders}
            isLoading={isLoading}
            loadingIcon="progress_activity"
            loadingIconVariant="primary"
            loadingIconClassName="animate-spin ease-in-out text-primary-10"
            textClassName="flex text-primary-10"
            textVariant="subtitle1"
            onPageChange={onPageChange}
            uniqueKey="id"
            initialPageSize={PAGE_SIZE_INICIAL}
            showPagination={true}
          />
        </div>
      </div>

      {mostrarVacio && (
        <div className="flex flex-col items-center mt-8 md:mt-12">
          <GrillaSinResultados
            icon="error"
            iconStyles="text-warning-20"
            title={mensajeVacio.TITULO}
            titleStyles="text-primary-10"
            description={mensajeVacio.DESCRIPCION}
          />
        </div>
      )}
    </div>
  )
}

CuentasSeleccionTable.propTypes = {
  headers: PropTypes.object.isRequired,
  tableData: PropTypes.array.isRequired,
  onPageChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  hayFiltroAplicado: PropTypes.bool,
  error: PropTypes.string,
}
